<template>
  <div class="data-page">
    <header class="data-header">
      <div class="brand">
        <router-link class="brand-logo-link" to="/dataProcess">
          <img
            class="logo"
            src="@/assets/img/echoingocean_logo.png"
            alt="EchoingOcean logo"
          />
        </router-link>
        <span class="brand-name">Remote Command Platform</span>
      </div>

      <div class="user-area">
        <nav class="header-nav">
          <div v-if="isAdmin" class="nav-group">
            <button class="nav-item nav-trigger" type="button">管理功能</button>
            <div class="nav-dropdown">
              <router-link class="nav-dropdown-item" to="/accountManage">帳號管理</router-link>
              <router-link class="nav-dropdown-item" to="/companyManage">客戶管理</router-link>
              <router-link class="nav-dropdown-item" to="/mobileManage">Mobile管理</router-link>
              <router-link class="nav-dropdown-item" to="/loginRecord">登入紀錄</router-link>
            </div>
          </div>
        </nav>
        <div class="user-menu">
          <button class="avatar-button" type="button" aria-label="使用者選單">
            <svg class="avatar-icon" viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="8" r="4" fill="currentColor" />
              <path
                d="M4 20c0-4 4-6 8-6s8 2 8 6"
                fill="none"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
              />
            </svg>
          </button>
          <div class="dropdown">
            <button class="dropdown-item" type="button" @click="openModifyPwd">
              修改密碼
            </button>
            <button class="dropdown-item" type="button" @click="userLogout">登出</button>
          </div>
        </div>
      </div>
    </header>

    <main class="data-content">
      <slot />
    </main>

    <div v-if="showModifyPwd" class="modal-backdrop">
      <div class="modal">
        <div class="modal-header">
          <h2>修改密碼</h2>
          <button class="modal-close" type="button" @click="closeModifyPwd">
            ×
          </button>
        </div>
        <div class="modal-body">
          <label class="modal-field">
            <span>舊密碼</span>
            <div class="modal-input">
              <input
                v-model="pwdForm.oldPassword"
                :type="showOld ? 'text' : 'password'"
                placeholder="請輸入舊密碼"
              />
              <button
                class="eye-button"
                type="button"
                @click="showOld = !showOld"
                :aria-label="showOld ? '隱藏密碼' : '顯示密碼'"
              >
                <svg
                  v-if="showOld"
                  class="eye-icon"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.6"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="3.5"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.6"
                  />
                </svg>
                <svg
                  v-else
                  class="eye-icon"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.6"
                  />
                  <path
                    d="M4 4l16 16"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.6"
                  />
                </svg>
              </button>
            </div>
          </label>

          <label class="modal-field">
            <span>新密碼</span>
            <div class="modal-input">
              <input
                v-model="pwdForm.newPassword"
                :type="showNew ? 'text' : 'password'"
                placeholder="請輸入新密碼"
              />
              <button
                class="eye-button"
                type="button"
                @click="showNew = !showNew"
                :aria-label="showNew ? '隱藏密碼' : '顯示密碼'"
              >
                <svg
                  v-if="showNew"
                  class="eye-icon"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.6"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="3.5"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.6"
                  />
                </svg>
                <svg
                  v-else
                  class="eye-icon"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.6"
                  />
                  <path
                    d="M4 4l16 16"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.6"
                  />
                </svg>
              </button>
            </div>
          </label>

          <label class="modal-field">
            <span>確認密碼</span>
            <div class="modal-input">
              <input
                v-model="pwdForm.confirmPassword"
                :type="showConfirm ? 'text' : 'password'"
                placeholder="請再次輸入密碼"
              />
              <button
                class="eye-button"
                type="button"
                @click="showConfirm = !showConfirm"
                :aria-label="showConfirm ? '隱藏密碼' : '顯示密碼'"
              >
                <svg
                  v-if="showConfirm"
                  class="eye-icon"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.6"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="3.5"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.6"
                  />
                </svg>
                <svg
                  v-else
                  class="eye-icon"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.6"
                  />
                  <path
                    d="M4 4l16 16"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.6"
                  />
                </svg>
              </button>
            </div>
          </label>
          <div v-if="pwdError" class="modal-message error">{{ pwdError }}</div>
          <div v-if="pwdSuccess" class="modal-message success">{{ pwdSuccess }}</div>
        </div>
        <div class="modal-footer">
          <button class="modal-button ghost" type="button" @click="closeModifyPwd">
            取消
          </button>
          <button
            class="modal-button primary"
            type="button"
            :disabled="isSavingPwd"
            @click="submitModifyPwd"
          >
            {{ isSavingPwd ? "儲存中..." : "儲存" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LOGOUT } from "@/store/mutationsType";
import { LOGOUT_USER, MODIFY_PASSWORD } from "@/utils/requestUrl";
import {
  clearSessionStorage,
  getToken,
  getUserId
} from "@/utils/sessionStoraggeUtil";

export default {
  name: "AppHeaderLayout",
  data() {
    return {
      showModifyPwd: false,
      pwdForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      },
      pwdError: "",
      pwdSuccess: "",
      isSavingPwd: false,
      showOld: false,
      showNew: false,
      showConfirm: false
    };
  },
  computed: {
    isAdmin() {
      const userInfo = this.$store.getters.getUserInfo || {};
      return userInfo.memberType === "A";
    }
  },
  methods: {
    getApiBase() {
      if (window._env_ && window._env_.VUE_APP_REQUEST_DOMAIN) {
        return window._env_.VUE_APP_REQUEST_DOMAIN;
      }
      return "";
    },
    openModifyPwd() {
      this.showModifyPwd = true;
    },
    closeModifyPwd() {
      this.showModifyPwd = false;
      this.pwdForm.oldPassword = "";
      this.pwdForm.newPassword = "";
      this.pwdForm.confirmPassword = "";
      this.pwdError = "";
      this.pwdSuccess = "";
      this.isSavingPwd = false;
      this.showOld = false;
      this.showNew = false;
      this.showConfirm = false;
    },
    async submitModifyPwd() {
      this.pwdError = "";
      this.pwdSuccess = "";

      const oldPwd = (this.pwdForm.oldPassword || "").trim();
      const newPwd = (this.pwdForm.newPassword || "").trim();
      const confirmPwd = (this.pwdForm.confirmPassword || "").trim();

      if (!oldPwd || !newPwd || !confirmPwd) {
        this.pwdError = "請完整輸入舊密碼、新密碼與確認密碼。";
        return;
      }

      if (newPwd !== confirmPwd) {
        this.pwdError = "新密碼與確認密碼不一致。";
        return;
      }

      const userInfo = this.$store.getters.getUserInfo || {};
      const account = userInfo.account || userInfo.Account || "";
      const updator = userInfo.memberId || userInfo.MemberId || getUserId() || "";

      if (!account || !updator) {
        this.pwdError = "無法取得使用者資訊，請重新登入後再試。";
        return;
      }

      const headers = {
        "Content-Type": "application/json"
      };
      const token = getToken();
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      this.isSavingPwd = true;
      try {
        const response = await fetch(this.getApiBase() + MODIFY_PASSWORD, {
          method: "POST",
          headers,
          body: JSON.stringify({
            Account: account,
            OldPwd: oldPwd,
            NewPwd: newPwd,
            Updator: updator
          })
        });

        let payload = null;
        try {
          payload = await response.json();
        } catch (error) {
          payload = null;
        }

        if (!response.ok) {
          this.pwdError = (payload && payload.message) || "修改密碼失敗，請稍後再試。";
          return;
        }

        if (payload && payload.status === "failure") {
          this.pwdError = payload.message || "修改密碼失敗，請確認舊密碼是否正確。";
          return;
        }

        this.pwdSuccess = "密碼修改成功。";
        setTimeout(() => {
          this.closeModifyPwd();
        }, 1000);
      } catch (error) {
        this.pwdError = "修改密碼失敗，請稍後再試。";
      } finally {
        this.isSavingPwd = false;
      }
    },
    async userLogout() {
      const userInfo = this.$store.getters.getUserInfo || {};
      const account = userInfo.account || userInfo.Account || "";
      const baseUrl = this.getApiBase();
      const token = getToken();
      const headers = {
        "Content-Type": "application/json"
      };

      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      try {
        await fetch(baseUrl + LOGOUT_USER, {
          method: "POST",
          headers,
          body: JSON.stringify({
            Account: account
          })
        });
      } catch (error) {
        console.error("logoutUser failed", error);
      } finally {
        this.$store.commit(LOGOUT);
        clearSessionStorage();
        this.$router.push("/login");
      }
    }
  }
};
</script>

<style scoped>
.data-page {
  min-height: 100vh;
  background: #f4f7f8;
  color: #1f2a33;
  font-family: var(--font-ui);
}

.data-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 32px;
  background: linear-gradient(to top, #001b33 0%, #004b6c 100%);
  border-bottom: 1px solid rgba(15, 30, 40, 0.08);
  gap: 16px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.brand-logo-link {
  color: inherit;
  text-decoration: none;
}

.logo {
  width: 208px;
  height: auto;
  object-fit: contain;
}

.brand-name {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #ffffff;
  white-space: nowrap;
  text-align: center;
}

.header-nav {
  display: flex;
  align-items: center;
  gap: 14px;
  height: 40px;
}

.nav-group {
  position: relative;
  padding-bottom: 12px;
}

.nav-item {
  font-size: 1rem;
  color: #ffffff;
  text-decoration: none;
  padding: 6px 4px;
  height: 40px;
  display: inline-flex;
  align-items: center;
}

.nav-trigger {
  background: transparent;
  border: none;
  cursor: pointer;
  height: 40px;
}

.nav-item:hover,
.nav-item.router-link-exact-active,
.nav-group:hover .nav-item {
  color: #aef3f5;
}

.nav-dropdown {
  position: absolute;
  top: 46px;
  left: 0;
  right: auto;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 12px 24px rgba(15, 30, 40, 0.15);
  padding: 8px;
  min-width: 120px;
  opacity: 0;
  transform: translateY(-6px);
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
  z-index: 2;
  overflow: hidden;
}

.nav-group:hover .nav-dropdown,
.nav-group:focus-within .nav-dropdown {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.nav-dropdown-item {
  display: block;
  width: 100%;
  padding: 8px 10px;
  box-sizing: border-box;
  border-radius: 8px;
  text-decoration: none;
  color: #1f2a33;
  font-size: 0.9375rem;
}

.nav-dropdown-item:hover,
.nav-dropdown-item.router-link-exact-active {
  background: rgba(10, 160, 165, 0.08);
}

.user-area {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  margin-left: auto;
}

.header-nav {
  margin-right: 12px;
}

.user-menu {
  position: relative;
  padding-bottom: 12px;
}

.avatar-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #0aa0a5;
  background: #f5ffff;
  color: #0aa0a5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

.avatar-icon {
  width: 22px;
  height: 22px;
}

.dropdown {
  position: absolute;
  right: 0;
  top: 46px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 12px 24px rgba(15, 30, 40, 0.15);
  padding: 10px;
  min-width: 120px;
  opacity: 0;
  transform: translateY(-6px);
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.user-menu:hover .dropdown,
.user-menu:focus-within .dropdown {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.dropdown-item {
  width: 100%;
  border: none;
  background: transparent;
  text-align: left;
  padding: 8px 10px;
  font-size: 0.9375rem;
  color: #1f2a33;
  cursor: pointer;
}

.dropdown-item:hover {
  background: rgba(10, 160, 165, 0.08);
  border-radius: 8px;
}

.data-content {
  padding: 32px;
}

.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(10, 16, 20, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.modal {
  width: min(420px, 90vw);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 24px 48px rgba(15, 30, 40, 0.2);
  padding: 20px 22px 18px;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.375rem;
}

.modal-close {
  border: none;
  background: transparent;
  font-size: 1.625rem;
  cursor: pointer;
  line-height: 1;
}

.modal-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.modal-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 0.9375rem;
}

.modal-input {
  position: relative;
  display: flex;
  align-items: center;
}

.modal-input input {
  width: 100%;
  height: 40px;
  border-radius: 10px;
  border: 1px solid rgba(20, 40, 50, 0.2);
  padding: 0 40px 0 12px;
  font-size: 0.9375rem;
}

.modal-input input:focus {
  outline: none;
  border-color: rgba(10, 160, 165, 0.7);
  box-shadow: 0 0 0 3px rgba(10, 160, 165, 0.15);
}

.modal-message {
  font-size: 0.875rem;
  border-radius: 10px;
  padding: 10px 12px;
  line-height: 1.4;
}

.modal-message.error {
  color: #b91c1c;
  background: rgba(220, 38, 38, 0.1);
  border: 1px solid rgba(220, 38, 38, 0.25);
}

.modal-message.success {
  color: #166534;
  background: rgba(22, 163, 74, 0.1);
  border: 1px solid rgba(22, 163, 74, 0.25);
}

.eye-button {
  position: absolute;
  right: 8px;
  border: none;
  background: transparent;
  color: rgba(31, 42, 51, 0.6);
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

.eye-icon {
  width: 18px;
  height: 18px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
}

.modal-button {
  min-width: 90px;
  height: 38px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-size: 0.9375rem;
}

.modal-button.ghost {
  background: #f1f4f6;
  color: #1f2a33;
}

.modal-button.primary {
  background: #0aa0a5;
  color: #ffffff;
}

.modal-button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

@media (max-width: 960px) {
  .data-header {
    flex-wrap: wrap;
  }

  .header-nav {
    order: 3;
    width: 100%;
    margin: 0;
    justify-content: flex-start;
  }

  .brand-name {
    position: static;
    transform: none;
  }
}

@media (max-width: 600px) {
  .brand-name {
    font-size: 1rem;
  }

  .logo {
    width: 110px;
  }
}
</style>



